module.exports = __webpack_public_path__ + "static/img/power.2e63cc7a.png";